import { HttpClient } from "@angular/common/http";

declare global {
    interface Window {
        preload: any;
    }
}
window.preload = window.preload || {};

let buId = "";
const path = window.location.pathname.split("/");
const buIndex = path.findIndex((a) => a == "bu");
if (path && buIndex > -1 && path.length >= buIndex + 1)
    buId = path[buIndex + 1];

export function identityFactory(http: HttpClient, buidOnSelect?: any) {
    return () => {
        buId = buidOnSelect || buId;
        const url = window.location.origin + "/api/me/" + buId;
        return http
            .get(url)
            .toPromise()
            .then((resp: any) => {
                window.preload.user = resp ? resp["reference"] : null;
            });
    };
}
